import { get, put, del } from 'utils/methods';

export function getFormsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}forms`, data, headers);
}

export function deleteFormApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_PP}commands/form`, data, headers);
}

export function updateFormApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_PP}commands/form`, data, headers);
}

export function editOrderItemApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_PP}commands/order-item`, data, headers);
}
